import React from 'react';
import { UserRole } from '../../../types/auth';

interface ViewingAsSwitcherProps {
  role: UserRole;
  displayName?: string | null;
  title?: string | null;
}

// "Viewing as [Name] — [Title]" indicator. Personalised: shows the signed-in
// user's name and their descriptive title (e.g. "Chief Financial Officer"),
// falling back to the access-level role when no title is set. Shared content
// (transcript, slides) and per-user content (Advisor, questions, insights) are
// distinguished by the functionality itself, so no view-mode toggle is needed.
const ViewingAsSwitcher: React.FC<ViewingAsSwitcherProps> = ({ role, displayName, title }) => {
  const name = displayName?.trim();
  // Prefer the descriptive title; fall back to a capitalised access-level role.
  const roleLabel = role ? role.charAt(0).toUpperCase() + role.slice(1) : role;
  const descriptor = title?.trim() || roleLabel;

  return (
    <div className="viewing-as">
      <span className="viewing-as-label">
        Viewing as{' '}
        {name ? (
          <>
            <strong className="viewing-as-name">{name}</strong>
            {descriptor && (
              <>
                {' '}
                — <span className="viewing-as-role">{descriptor}</span>
              </>
            )}
          </>
        ) : (
          <strong className="viewing-as-role">{descriptor}</strong>
        )}
      </span>
    </div>
  );
};

export default ViewingAsSwitcher;
